"use client";

import authSettings from "@/shared/config/authSettings";
import GenericIcon from "@/shared/ui/actions/GenericIcon";
import { PublicActionButton } from "@/shared/public-ui";
import useBrowserAuthSession from "./useBrowserAuthSession";

export default function RegisterTodayButton() {
  const isAuthenticated = useBrowserAuthSession();

  const href = isAuthenticated
    ? authSettings.redirects.privateHome
    : authSettings.redirects.register;

  return (
    <PublicActionButton
      asChild
      size={{
        base: "md",
        md: "lg",
      }}
    >
      <a href={href}>
        <GenericIcon icon="log_in" />
        {isAuthenticated ? "Open app" : "Register today"}
      </a>
    </PublicActionButton>
  );
}
